import { Box, Stack, Typography } from '@mui/material'
import type { JSX } from 'react'
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { getDeviceDetails } from '@/api/Device'
import Card from '@/components/Card/Card'
import CardHeader from '@/components/Card/CardHeader'
import type { Device } from '@/pages/Device/Device'
import DurationTestReports from '@/pages/Device/Reports/DurationTest'
import RdiReports from '@/pages/Device/Reports/Rdi'
import RssReports from '@/pages/Device/Reports/Rss'
import ZklRcReports from '@/pages/Device/Reports/Zklrc'
import {
  RCS_3000,
  RDI_3000,
  RSS_3000,
  RSS_3000_PC,
} from '@/pages/Device/SupportedTypes'
import RcsReports from '@/pages/Device/Reports/Rcs'

export default function DeviceReports(): JSX.Element {
  const { uid } = useParams<{ uid: string }>()
  const [t] = useTranslation('app')
  const [device, setDevice] = useState<Device>()

  const fetchData = useCallback(async () => {
    if (!uid) {
      return <></>
    }
    try {
      const data = await getDeviceDetails(uid)
      setDevice(data)
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }, [uid])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  if (!device) {
    return <></>
  }

  let reportComponent
  if (device.type === RDI_3000) {
    reportComponent = <RdiReports />
  } else if (device.type === RSS_3000 || device.type === RSS_3000_PC) {
    reportComponent = <RssReports deviceType={device.type} />
  } else if (device.type === RCS_3000) {
    reportComponent = <RcsReports />
  } else {
    reportComponent = <ZklRcReports />
  }

  return (
    <Box sx={{ padding: '24px' }}>
      <Card>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <CardHeader>
            <Typography variant="h4">
              {t('device.report.deliveryReports')}
            </Typography>
          </CardHeader>
        </Stack>
        {reportComponent}
      </Card>
      <Card>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <CardHeader>
            <Typography variant="h4">
              {t('device.report.durationTestReports')}
            </Typography>
          </CardHeader>
        </Stack>
        <DurationTestReports />
      </Card>
    </Box>
  )
}
